
<template>
    <div class="location_general">

        <b-tabs content-class="mt-3 mb-4">
            <b-tab v-for="(tab,index) in tabs" @click="set_active(index)" :title="get_tab_title(tab)" :key="index" :active="tab.is_active">
                <template slot="title">
                    {{get_tab_title(tab)}}
                    <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                </template>

                <div class="form-group mt-2" v-if="tab.index == 'general_base_params'">
                    <label class="form-label" for="linked_rest">
                        {{__t("LINKED_REST")}}
                    </label>

                    <div class="" v-if="restaurants.length > 0">
                        <v-select v-model="location.link_id"
                                  class="imc_reasons"
                                  id="linked_rest"
                                  label="title"
                                  :reduce="rest => rest.id"
                                  :filter="searchRest"
                                  :options="restaurants"
                        >
                            <template slot="no-options">
                                {{__t("CHOOSE_POS_REST")}}
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    <div>
                                        {{ option.title }}
                                    </div>
                                    <div>
                                        <small>
                                            {{option.uniq_id}} {{option.address}}
                                        </small>
                                    </div>
                                </div>
                            </template>
                        </v-select>
                    </div>


                    <div class="mt-4" v-if="marketings.length > 0">
                        <label class="form-label" for="marketing">
                            {{__t("MARKETING")}}
                        </label>

                        <div class="" >
                            <v-select v-model="location.marketing_uniq_id"
                                      class="imc_reasons"
                                      id="marketing"
                                      label="name"
                                      :reduce="item => item.id"
                                      :options="marketings"
                            >
                                <template slot="no-options">
                                    {{__t("CHOOSE_POS_REST")}}
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        <div>
                                            {{ option.name }}
                                        </div>
                                        <div>
                                            <small>
                                                {{option.id}}
                                            </small>
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                        </div>
                    </div>
                </div>


                <div class="payment mt-2" v-if="tab.index == 'payments'">
                    <div class="panel-tag">
                        {{__t("PAYMENT_PARAM")}}
                    </div>
                    <location_payment :location="location"></location_payment>
                </div>

                <div class="shipment mt-2" v-if="tab.index == 'shipments'">
                    <div class="panel-tag ">
                        {{__t("SHIPMENT_PARAM")}}
                    </div>
                    <location_shipment :location="location"></location_shipment>
                </div>

                <div class="auto_delivery" v-if="tab.index == 'auto_delivery'">
                    <delivery_block
                        @on_change_delivery_settings="set_delivery_settings"
                        :location="location"
                    ></delivery_block>
                </div>

            </b-tab>
        </b-tabs>

    </div>
</template>

<script>
import vSelect from 'vue-select';
import Fuse from 'fuse.js';
import Location_payment from "./payment/location_payment.vue";
import Location_shipment from "./shipment/location_shipment.vue";
import Delivery_block from "./delivery_block/delivery_block.vue";

export default {
    name: "location_general_params",
    components : {
        Delivery_block,
        Location_shipment,
        Location_payment,
        vSelect
    },

    props : {

        location : {
            type : Object
        },

        show_payment : {
            type : Boolean,
            default : true
        },

        show_shipment : {
            type : Boolean,
            default : true
        },

        show_auto_delivery : {
            type : Boolean,
            default : true
        },

        show_choice_rest : {
            type : Boolean,
            default : true
        }
    },

    data() {
        return {
            restaurants : [],
            tabs : [],
            marketings : [],
        }
    },

    mounted() {
        this.init_tabs();
        this.load_restaurants();
        this.load_marketings();
    },


    created() {
        EventBus.$on('reload_rest_list',this.load_restaurants);
    },

    methods : {
        set_delivery_settings(param) {
            console.log('change_params',param);
            EventBus.$emit('change_delivery_params',{
                'loc_id' : this.location.id,
                'params' : param
            });
        },
        init_tabs() {
            this.tabs = [];

            if(this.show_choice_rest) {
                let base = {
                    "title": this.__t('MAIN_SETTINGS'),
                    "index": "general_base_params",
                    is_active: true,
                };

                this.tabs.push(base);
            }

            if(this.show_payment) {
                this.tabs.push({
                    "title": this.__t('PAYMENTS'),
                    "index": "payments",
                    is_active:false,
                })
            }

            if(this.show_shipment) {
                this.tabs.push({
                    "title": this.__t('SHIPMENT'),
                    "index": "shipments",
                    is_active:false,
                })
            }

            if(this.show_auto_delivery && parseInt(this.location.id) > 0) {
                this.tabs.push({
                    "title": this.__t('AUTO_DELIVERY'),
                    "index": "auto_delivery",
                    is_active:false,
                })
            }

        },

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },

        set_active (obj) {
            for (let tab in this.tabs) {
                this.tabs[tab].is_active = false;
            }
            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },

        searchRest(options, search) {
            const fuse = new Fuse(options, {
                keys: ['title', 'uniq_id', 'address'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },

        async load_restaurants() {
            this.restaurants = [];
            await api.post('/internal/v1/catalog/restaurants', {
                "filter": {
                    "organizations": [this.location.parent_id]
                },
                "list": {
                    "limit": 200
                }
            }).then(({data}) => {
                if (data.status === "operation_success") {
                    this.restaurants = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async load_marketings() {
            this.marketings = [];
            await pos_api.get('/pos/' + this.location.organization.provider_id+'/market/' + this.location.parent_id +'/sources').then(({data}) => {
                if (data.status === "operation_success") {
                    this.marketings = data.data;
                }
            }).catch(({response}) => {
               // EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },

    computed : {

    }

}
</script>


<style scoped>

</style>
